import { Component, OnInit, Input } from '@angular/core';
import { Gto } from '../../base/vo/gto';
import { CancelaGTO } from '../../base/vo/cancela-gto';
import { DialogModule } from 'primeng/dialog';
import { AcoesService } from '../acoes.service';
import { AutenticacaoService } from '../../autenticacao/autenticacao.service';


@Component({
  selector: 'app-acao-salvar',
  templateUrl: './acao-salvar.component.html',
  styleUrls: ['./acao-salvar.component.css']
})
export class AcaoSalvarComponent implements OnInit {

  @Input() numeroGto;
  salvarGTO: Gto;
  errorMsg = false;

  constructor(private acoesService: AcoesService){
                this.salvarGTO = new Gto;
               }

  ngOnInit() {
  }

  onSubmit(form){

    if(form.control.invalid){
        this.errorMsg = true;
        return;
    }
    this.salvar();
}

  salvar(): void {
        
    this.acoesService.salvarGTO(this.salvarGTO)
        .subscribe(data => {
        }, error => console.log('Mensagem de erro'));
}

}



// WEBPACK FOOTER //
// ./src/app/components/acoes/acao-salvar/acao-salvar.component.ts